var _dec, _class, _RGBAInput, _span;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import { withStyle } from '@instructure/emotion';
import shallowCompare from "../utils/shallowCompare.js";
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { TextInput } from '@instructure/ui-text-input';
import { allowedProps } from "./props.js";
import generateStyle from "./styles.js";
import generateComponentTheme from "./theme.js";
/**
---
private: true
---
**/
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
let RGBAInput = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_RGBAInput = class RGBAInput extends Component {
  constructor(props) {
    super(props);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
    this.state = {
      value: props.value
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
  }
  componentDidUpdate(prevProps) {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
    if (shallowCompare(prevProps.value, this.props.value) || shallowCompare(this.state.value, this.props.value)) {
      this.setState({
        value: this.props.value
      });
    }
  }
  handleChange(type, e) {
    const upperLimit = type === 'a' ? 100 : 255;
    const newValue = type === 'a' ? Number(e.target.value) / 100 : Number(e.target.value);
    const newColor = {
      ...this.props.value,
      [type]: newValue
    };
    if (!isNaN(Number(newValue)) && newValue >= 0 && newValue <= upperLimit) {
      this.setState({
        value: newColor
      });
      this.props.onChange(newColor);
      return;
    }
  }
  render() {
    const _this$props3 = this.props,
      styles = _this$props3.styles,
      disabled = _this$props3.disabled,
      label = _this$props3.label,
      withAlpha = _this$props3.withAlpha;
    return _jsxs("div", {
      ref: this.handleRef,
      css: styles === null || styles === void 0 ? void 0 : styles.RGBAInput,
      children: [label && _jsx("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.label,
        children: label
      }), _jsxs("div", {
        css: styles === null || styles === void 0 ? void 0 : styles.inputContainer,
        children: [_jsx("span", {
          css: styles === null || styles === void 0 ? void 0 : styles.rgbInput,
          children: _jsx(TextInput, {
            disabled: disabled,
            value: `${this.state.value.r}`,
            onChange: e => this.handleChange('r', e),
            renderLabel: _jsx(ScreenReaderContent, {
              children: this.props.rgbRedInputScreenReaderLabel
            })
          })
        }), _jsx("span", {
          css: styles === null || styles === void 0 ? void 0 : styles.rgbInput,
          children: _jsx(TextInput, {
            disabled: disabled,
            value: `${this.state.value.g}`,
            onChange: e => this.handleChange('g', e),
            renderLabel: _jsx(ScreenReaderContent, {
              children: this.props.rgbGreenInputScreenReaderLabel
            })
          })
        }), _jsx("span", {
          css: styles === null || styles === void 0 ? void 0 : styles.rgbInput,
          children: _jsx(TextInput, {
            disabled: disabled,
            value: `${this.state.value.b}`,
            onChange: e => this.handleChange('b', e),
            renderLabel: _jsx(ScreenReaderContent, {
              children: this.props.rgbBlueInputScreenReaderLabel
            })
          })
        }), withAlpha && _jsx("span", {
          css: styles === null || styles === void 0 ? void 0 : styles.aInput,
          children: _jsx(TextInput, {
            "aria-label": "%",
            disabled: disabled,
            value: `${Math.round(this.state.value.a * 100)}`,
            onChange: e => this.handleChange('a', e),
            renderAfterInput: _span || (_span = _jsx("span", {
              "aria-hidden": "true",
              role: "presentation",
              children: "%"
            })),
            renderLabel: _jsx(ScreenReaderContent, {
              children: this.props.rgbAlphaInputScreenReaderLabel
            })
          })
        })]
      })]
    });
  }
}, _RGBAInput.displayName = "RGBAInput", _RGBAInput.allowedProps = allowedProps, _RGBAInput.componentId = 'ColorMixer.RGBAInput', _RGBAInput.defaultProps = {
  withAlpha: false
}, _RGBAInput)) || _class);
export default RGBAInput;